import client from '../utils/client';
import { productCarouselsUrl } from '../store/constants/api';
import { cookieConstants } from '../store/constants';
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

export const productCarouselService = {
  productCarouselList,
  addProductCarousel,
  getProductCarousel,
  updateProductCarousel,
};

function productCarouselList(pageID, perPage, searchInput = '') {
  let searchQuery = '';
  if (searchInput !== '') {
    searchQuery = '&s=' + searchInput;
  }
  return client
    .get(productCarouselsUrl + '?page=' + pageID + '&per_page=' + perPage + searchQuery)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function addProductCarousel(formDate) {
  return client
    .post(productCarouselsUrl + '/create', formDate)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function getProductCarousel(productCarouselID) {
  return client
    .get(productCarouselsUrl + '/' + productCarouselID + '/show')
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function updateProductCarousel(formDate) {
  return client
    .post(productCarouselsUrl + '/update', formDate)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: '/' });
  cookies.remove(cookieConstants.USER, { path: '/' });
}

function handleResponse(response) {
  response = response.response;
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}
